@let canEdit = EPermissions.campaignUpdateOwn | hasPermission;

<app-side-dialog [contentMarginTop]="20" [disableClose]="true" (closeDialog)="onDoneClick()">
  <div dialogHeader>
    <span class="text-[28px] font-medium">{{ 'pages.campaignDetails.export.sharedReports' | translate }}</span>
  </div>

  <div dialogContent class="flex flex-col gap-3">
    @if (store.loading$() && store.campaignExports$().length === 0) {
      @for (i of [1, 2, 3]; track i) {
        <ngx-skeleton-loader class="h-[74px]" [theme]="{ height: '74px', width: '100%', 'border-radius': '16px' }" />
      }
    } @else {
      @if (!canEdit && store.campaignExports$().length === 0) {
        <p data-testid="campaign-export-no-reports" class="text-sm text-shikenso-purple-base-60">
          {{ 'pages.campaignDetails.export.noSharedReports' | translate }}
        </p>
      }

      <div
        cdkDropList
        cdkDropListOrientation="vertical"
        class="flex flex-col gap-3"
        (cdkDropListDropped)="onDrop($event)"
      >
        @for (campaignExport of store.campaignExports$(); track campaignExport.id) {
          @let isDragDisabled = !canEdit || store.campaignExports$().length < 2 || store.busy$();

          <div cdkDrag [cdkDragDisabled]="isDragDisabled">
            <div class="campaign-export-panel-drag-placeholder" *cdkDragPlaceholder></div>

            <app-campaign-export-panel
              [campaignExport]="campaignExport"
              [campaignAnalytics]="campaignAnalytics()"
              [analyticsNodes]="analyticsNodes()"
              [platformFeaturesKpis]="store.platformFeaturesKpis$()"
              [expanded]="canEdit && effectiveExpandedId() === campaignExport.id"
              [dragDisabled]="isDragDisabled"
              (openAttempt)="onPanelOpenAttempt(campaignExport.id!)"
              (closeAttempt)="onCloseAttempt(campaignExport.id!)"
              (saved)="onSaved($event)"
              (deleteRequested)="onDeleteRequested(campaignExport.id!)"
              (dirtyChange)="onDirtyChange(campaignExport.id!, $event)"
              (nameEditRequested)="onNameEditRequested(campaignExport.id!)"
            />
          </div>
        }
      </div>
    }

    @if (canEdit) {
      <button
        mat-flat-button
        type="button"
        data-testid="campaign-export-add-report-button"
        class="w-full mat-thick-button"
        color="secondary-gray-border"
        [disabled]="store.busy$()"
        (click)="onAddReportClick()"
      >
        <div class="flex items-center gap-1 justify-center">
          @if (store.creatingExport$()) {
            <app-dots-spinner />
          } @else {
            <app-icon src="/icons/plus.svg" alt="add" class="w-5 h-5 self-center" />
            {{ 'pages.campaignDetails.export.addReport' | translate }}
          }
        </div>
      </button>
    }

    <!-- <div
      class="sticky flex bottom-[-1px] left-0 right-0 pt-4 pb-[1px] z-10 bg-white border-t border-shikenso-purple-base-12 justify-end"
    >
      <button mat-flat-button type="button" color="secondary" (click)="onDoneClick()">
        {{ 'pages.campaignDetails.export.done' | translate }}
      </button>
    </div> -->
  </div>
</app-side-dialog>
